

CommonControllersDeclarationJS = {
       langId: "-1",

       storeId: "",

       catalogId: "",

       ajaxCheckOut: true,

       setCommonParameters:function(langId,storeId,catalogId){
              this.langId = langId;
              this.storeId = storeId;
              this.catalogId = catalogId;
       },

       setControllerURL:function(controllerId,url){
    	   if(typeof(wc.render.getRefreshControllerById(controllerId))!="undefined"){
    		   wc.render.getRefreshControllerById(controllerId).url = url;
    	   }
       }

}

wc.render.declareRefreshController({
       id: "CategoryDisplay_Controller",
       renderContext: wc.render.getContextById("CategoryDisplay_Context"),
       url: "",
       formId: ""

       ,renderContextChangedHandler: function(message, widget) {
              var controller = this;
              var renderContext = this.renderContext;
              categoryDisplayJS.contextChanged = true;
              widget.refresh(renderContext.properties);

                     }

       ,postRefreshHandler: function(widget) {
              var controller = this;
              var renderContext = this.renderContext;
              if (categoryDisplayJS.contextChanged && (!categoryDisplayJS.isHistory)){

                       var identifier = "&identifier=" + (new Date()).getTime();


                                                                    var historyObject = new categoryDisplayJS.HistoryTracker('CategoryDisplay_Widget', controller.url + identifier);
                       dojo.back.addToHistory(historyObject);       
                       categoryDisplayJS.contextChanged = false;
                       categoryDisplayJS.isHistory = false;  
              }
              cursor_clear();

                            try {
			  	if(typeof(ceadojo) != "undefined") {
            	  ceadojo.publish("/wc/collaboration/CategoryDisplayRefreshed",[]);
			  	}
              }catch(err) {
            	  console.log(err);
              }


                     }

}),

wc.render.declareRefreshController({
       id: "SubCategoryDisplay_Controller",
       renderContext: wc.render.getContextById("SubCategoryDisplay_Context"),
       url: "",
       formId: ""

       ,renderContextChangedHandler: function(message, widget) {
              var controller = this;
              var renderContext = this.renderContext;
              categoryDisplayJS.contextChanged = true;
              widget.refresh(renderContext.properties);

                     }

       ,postRefreshHandler: function(widget) {
              var controller = this;
              var renderContext = this.renderContext;
              if (categoryDisplayJS.contextChanged && (!categoryDisplayJS.isHistory)){

                       var identifier = "&identifier=" + (new Date()).getTime();


                                                                    var historyObject = new categoryDisplayJS.HistoryTracker('SubCategoryDisplay_Widget', controller.url + identifier);
                       dojo.back.addToHistory(historyObject);       
                       categoryDisplayJS.contextChanged = false;
                       categoryDisplayJS.isHistory = false;  
              }
              cursor_clear();

       }

}),

wc.render.declareRefreshController({
	id: "PetcoShippingAdddressDisplayAreaController",
	renderContext: wc.render.getContextById("editShippingAddressContext"),
	url: "",
	formId: ""


	   ,renderContextChangedHandler : function(message, widget) {
	   var controller = this;
	   var renderContext = this.renderContext;
	   console.log("PetcoShippingAdddressDisplayAreaController renderContext.properties "+renderContext.properties);
	   widget.refresh(renderContext.properties);
   },
   postRefreshHandler: function(widget) {
	   var bopusRdOrder = false;
	   $("input[name='bopusrd_orderitemid']").each(function () {
		   console.log("BopusRD item Id "+$(this).val());
		   bopusRdOrder = true;
	   });
	   if (bopusRdOrder === true) {
		   CheckoutHelperJS.saveBopusRDAddress(dojo.byId('selectedShippingAdressId').value);
	   }
	   CheckoutHelperJS.isLoggedInAddressValid();
	   CheckoutHelperJS.disablePlaceOrderButton();
	   CheckoutHelperJS.deliveryInstructionRefresh();
   }
}),
wc.render.declareRefreshController({
	id: "PetcoGuestShippingAdddressDisplayAreaController",
	renderContext: wc.render.getContextById("editGuestShippingAddressContext"),
	url: "",
	formId: ""


	   ,renderContextChangedHandler : function(message, widget) {
	   var controller = this;
	   var renderContext = this.renderContext;
	   widget.refresh(renderContext.properties);
   },
   postRefreshHandler: function(widget) {
	  if(dojo.byId("scriptstoexecuteAfterpageLoad") != null){
		  eval(dojo.byId("scriptstoexecuteAfterpageLoad").innerHTML);
	  }
	  $(".disabled-section").removeClass("disabled-section")
	  wc.render.updateContext("PetcoGC_Context", null, "");	
	  wc.render.updateContext('PetcoPromotion_Context', null, "");
	  wc.render.updateContext("PetcoCheckoutCartSummary_Context", null, "");
	  wc.render.updateContext('traditionalShipmentDetailsContext',{'beginIndex' : '0'}, "");
	  wc.render.updateContext('PetcoOrderSummary_Context', null, "");
	  wc.render.updateContext("PetcoPaymentArea_Context", null, "");
	  wc.render.updateContext('PetcoOrderTotalSummary_Context',{'beginIndex' : '0','fromPage':'paymentMethodPage'}, "");
	  wc.render.updateContext("PetcoRxPetVetDisplayAreaContext", null, "");
	  CheckoutHelperJS.disablePlaceOrderButton();
	  setTimeout(function(){cursor_clear()},500);
   }


   }),
wc.render.declareRefreshController({
	id: "PetcoPromotionDisplayAreaController",
	renderContext: wc.render.getContextById("PetcoPromotion_Context"),
	url: "",
	formId: ""


	   ,renderContextChangedHandler : function(message, widget) {
	    console.log("context updated  (renderContextChangedHandler)");
	   var controller = this;
	   var renderContext = this.renderContext;
	   widget.refresh(renderContext.properties);
   },
   postRefreshHandler: function(widget) {
		 console.log("Widget Refreshed  (postRefreshHandler)");
   }


   }),
wc.render.declareRefreshController({
	id: "PetcoGiftCardDisplayAreaController",
	renderContext: wc.render.getContextById("PetcoGC_Context"),
	url: "",
	formId: ""


	   ,renderContextChangedHandler : function(message, widget) {
	   var controller = this;
	   var renderContext = this.renderContext;
	   widget.refresh(renderContext.properties);
   },
   postRefreshHandler: function(widget) {
	   CheckoutHelperJS.disablePlaceOrderButton();
	   if(document.getElementById('balance_Order_Total')!= null && document.getElementById('isDonationItemPresent')!= null && document.getElementById('gc_Eligible_balance_amount') != null && document.getElementById('gc_Paid_amount') != null){
			var balanceOrdTotal = document.getElementById('balance_Order_Total').value;	
			 var isDonationItemPresent = document.getElementById('isDonationItemPresent').value;
			 var gcEligiblebalanceamount =  document.getElementById('gc_Eligible_balance_amount').value;
			 var gcPaidamount = document.getElementById('gc_Paid_amount').value;
			 var gcRestrictedRDItemTotalPrice = document.getElementById('gc_Restricted_RD_Item_total_price').value;
			 if (isDonationItemPresent == 'true' && balanceOrdTotal > 0 && parseFloat(gcEligiblebalanceamount) == 0 && parseFloat(gcPaidamount) > 0) {
				document.getElementById('gc-donoation-info').style.display = 'block';
			 } else {
				var y = document.getElementById('gc-donoation-info');
					if (y != null && y.style.display === 'block')
						y.style.display = 'none';
			 }
			 if (balanceOrdTotal > 0 && parseFloat(gcRestrictedRDItemTotalPrice) > 0 && parseFloat(gcPaidamount) > 0) {
					document.getElementById('gc-repeatDelivery-info').style.display = 'block';
				 } else {
					var y = document.getElementById('gc-repeatDelivery-info');
						if (y != null && y.style.display === 'block')
							y.style.display = 'none';
				 }
		}
   }


   }),
wc.render.declareRefreshController({
	id: "PetcoOrderSummaryAreaController",
	renderContext: wc.render.getContextById("PetcoOrderTotalSummary_Context"),
	url: "",
	formId: ""

	,modelChangedHandler: function(message, widget) {
		var controller = this;
		var renderContext = this.renderContext;
		if(message.actionId == "AjaxGetPetcoGCBalance"){
			widget.refresh(renderContext.properties);
		}
	}
   ,renderContextChangedHandler : function(message, widget) {
	   var controller = this;
	   var renderContext = this.renderContext;
	   widget.refresh(renderContext.properties);
   },
   postRefreshHandler: function(widget) {

	   cursor_clear();
	   CheckoutHelperJS.checkIfTotalIsZeroInOrderTotal();
	   CheckoutHelperJS.deliveryInstructionRefresh();
	   CheckoutHelperJS.hideMembershipEarningPoints();
	   if(document.getElementById('earningIcon') != null){
			document.getElementById('earningIcon').onclick = function() {
		    	document.getElementById('membershipInfoModal').classList.add('show');
		    	document.body.style.overflow = 'hidden';
			}
		}

		if(document.querySelector('.membership-modal-close') != null){
			document.querySelector('.membership-modal-close').onclick = function() {
		    	document.getElementById('membershipInfoModal').classList.remove('show');
		    	document.body.style.overflow = '';
			}
		}

		if(document.getElementById('membershipInfoModal') != null){
			window.onclick = function(event) {
		    	if (event.target == document.getElementById('membershipInfoModal')) {
		        	document.getElementById('membershipInfoModal').classList.remove('show');
		        	document.body.style.overflow = '';
		    	}
			}
		}
		var expiryMsg = MessageHelper.messages["EE_MEMBERSHIP_POINTS_EXPIRY_DYNAMIC"];
		var expiryDuration = document.getElementById("expirationDays");		
		if(expiryMsg != undefined && expiryMsg != null && expiryDuration != undefined && expiryDuration != null ){
			expiryMsg = expiryMsg.replace('{0}', expiryDuration.value);
			$("li.membership-reason-list-point:eq(1)").text(expiryMsg);
		}
   }


   }),
wc.render.declareRefreshController({
	id: "PetcoCheckoutCartSummaryController",
	renderContext: wc.render.getContextById("PetcoCheckoutCartSummary_Context"),
	url: "",
	formId: ""


	   ,renderContextChangedHandler : function(message, widget) {
	   var controller = this;
	   var renderContext = this.renderContext;
	   widget.refresh(renderContext.properties);
   },
   postRefreshHandler: function(widget) {
	   CheckoutHelperJS.updateCartSummaryCount();

	   	   if (null != document.getElementById("orderId") && document.getElementById("HolidayShipMsgFlag") != null && document.getElementById("HolidayShipMsgFlag").value == 'Y') {
			 getShippingMessage(petcoCommonJS.storeId , petcoCommonJS.catalogId, petcoCommonJS.langId, document.getElementById('orderId').value, 'N', '', '');
	   }
   }


   }),

wc.render.declareRefreshController({
	id: "PetcoCheckoutShippingRestrictions_Controller",
	renderContext: wc.render.getContextById("PetcoCheckoutShippingRestrictions_Context"),
	url: "",
	formId: "",

	 	renderContextChangedHandler : function(message, widget) {
	   var controller = this;
	   var renderContext = this.renderContext;
	   widget.refresh(renderContext.properties);
   },
	   postRefreshHandler: function(widget) {

	   			   }


   }),
wc.render.declareRefreshController({
	id: "PetcoPaymentAreaController",
	renderContext: wc.render.getContextById("PetcoPaymentArea_Context"),
	url: "",
	formId: ""


	   ,renderContextChangedHandler : function(message, widget) {
	   var controller = this;
	   var renderContext = this.renderContext;
	   widget.refresh(renderContext.properties);
   },
   postRefreshHandler: function(widget) {
	   CheckoutHelperJS.deliveryInstructionRefresh();
	   	   var isPromoCodeQualifiedMsg = document.getElementById("isPromoCodeQualified").value;
   	   $('#promo-reg-info').css({ display: "none" });
		   if((document.getElementById("newRedundantPromoCode")!= undefined || document.getElementById("newRedundantPromoCode") != null) && (document.getElementById("newBestPromoCodeApplied")!= undefined || document.getElementById("newBestPromoCodeApplied") != null)){
		   var previousBestPromoCode = document.getElementById("bestPromoCodeApplied").value;
			var bestPromoCode = document.getElementById("newBestPromoCodeApplied").value;
			var previousRedundantPromoCode = document.getElementById("redundantPromoCode").value;
			var redundantPromoCode = document.getElementById("newRedundantPromoCode").value;
			if("" != isPromoCodeQualifiedMsg){
				$('#promo-conflict').css({ display: "none" });
				$('#promo-reg-info').css({ display: "block" });
				document.getElementById("promo-reg-info").innerHTML = isPromoCodeQualifiedMsg;
			}else if((previousBestPromoCode == '')&&(redundantPromoCode==''))
			{
			$('#promo-conflict').css({ display: "none" });
			$('#promo-conflict-info').css({ display: "none" });
			document.getElementById("bestPromoCodeApplied").value = bestPromoCode;
			document.getElementById("redundantPromoCode").value = redundantPromoCode;
			}
			else if((previousBestPromoCode == bestPromoCode) && (previousRedundantPromoCode != redundantPromoCode))
			{
			$('#promo-conflict').css({ display: "none" });
			$('#promo-conflict-info').css({ display: "block" });
			document.getElementById("bestPromoCodeApplied").value = bestPromoCode;
			document.getElementById("redundantPromoCode").value = redundantPromoCode;
			}
			else if((previousBestPromoCode != bestPromoCode)&&(bestPromoCode !='')&&(previousRedundantPromoCode != redundantPromoCode))
			{
			$('#promo-conflict').css({ display: "block" });	
			$('#promo-conflict-info').css({ display: "none" });
			document.getElementById("bestPromoCodeApplied").value = bestPromoCode;
			document.getElementById("redundantPromoCode").value = redundantPromoCode;
			}
			else
			{
			$('#promo-conflict').css({ display: "none" });
			$('#promo-conflict-info').css({ display: "none" });
			document.getElementById("bestPromoCodeApplied").value = bestPromoCode;
			document.getElementById("redundantPromoCode").value = redundantPromoCode;
			}
		}else if("" != isPromoCodeQualifiedMsg){
			$('#promo-conflict').css({ display: "none" });
			$('#promo-reg-info').css({ display: "block" });
			document.getElementById("promo-reg-info").innerHTML = isPromoCodeQualifiedMsg;
		}
		 var balanceOrdTotal = document.getElementById('balance_Order_Total').value;	
		 var isDonationItemPresent = document.getElementById('isDonationItemPresent').value;
		 var gcEligiblebalanceamount =  document.getElementById('gc_Eligible_balance_amount').value;
		 var gcPaidamount = document.getElementById('gc_Paid_amount').value;
		 var isGCRestricted = document.getElementById('isGCRestricted').value;
		 if (isDonationItemPresent == 'true' && balanceOrdTotal > 0 && parseFloat(gcEligiblebalanceamount) == 0 && parseFloat(gcPaidamount) > 0) {
			document.getElementById('gc-donoation-info').style.display = 'block';
		 } else {
			var y = document.getElementById('gc-donoation-info');
				if (y != null && y.style.display === 'block')
					y.style.display = 'none';
		 }
		 if(isGCRestricted == 'true' && balanceOrdTotal > 0 && parseFloat(gcEligiblebalanceamount) == 0 && parseFloat(gcPaidamount) > 0) {
			document.getElementById('gc-repeatDelivery-info').style.display = 'block';
		 } else {
			var y = document.getElementById('gc-repeatDelivery-info');
				if (y != null && y.style.display === 'block')
					y.style.display = 'none';
		 }
		console.log("balanceOrdTotal-"+balanceOrdTotal+"-isDonationItemPresent-"+isDonationItemPresent+"-gcEligiblebalanceamount-"+gcEligiblebalanceamount);  
		CheckoutHelperJS.gcAmountUpdate();

		   if(typeof(this.renderContext.properties["isaddGC"]) != "undefined" && this.renderContext.properties["isaddGC"]){
			  var params = [];
			  params=this.renderContext.properties;
			  params["isaddGC"]=false;
			  cursor_wait();
			   wc.service.invoke('AjaxGetPetcoGCBalance',params);
		   }
   }


   }),
wc.render.declareRefreshController({
	id: "PetcoRegUserCCAreaController",
	renderContext: wc.render.getContextById("PetcoRegUserCCArea_Context"),
	url: "",
	formId: ""


	   ,renderContextChangedHandler : function(message, widget) {
	   var controller = this;
	   var renderContext = this.renderContext;
	   widget.refresh(renderContext.properties);
   },
   postRefreshHandler: function(widget) {
	   CheckoutHelperJS.isCardRequired();
   }


   }),
wc.render.declareRefreshController({
       id: "ShopCartDisplayController",
       renderContext: wc.render.getContextById("ShopCartPaginationDisplay_Context"),
       url: "",
       formId: ""

       ,modelChangedHandler: function(message, widget) {
              var controller = this;
              var renderContext = this.renderContext;
              if(message.actionId in order_updated){
           	   if($('#paymentPalsrewardsRefreshArea').length > 0){
          		  parseWidget("paymentPalsrewardsRefreshArea");
          	  }
	               widget.refresh(renderContext.properties);
	               if(message.actionId  == "AjaxDeleteOrderItem"){
	            	}else if(message.actionId  == "AjaxUpdateOrderItem"){
	            	}
				   submitRequest(); 
				   cursor_wait();
              }
       }

       ,postRefreshHandler: function(widget) {
    	petcoCommonJS.displayZipcodeForSameday();	   
       if(typeof(CheckoutHelperJS)!="undefined"){
    	CheckoutHelperJS.invokeDeliveryDateAPI("cart");   
       	CheckoutHelperJS.callutagforcartupdate(CheckoutHelperJS.callutagforcartupdateCurrentAction);
       	CheckoutHelperJS.callutagforcartupdateCurrentAction="";
       	var promoDisplayButtonObj = dojo.byId("promoDisplayButton");
       	if(promoDisplayButtonObj != null && promoDisplayButtonObj.value != "" && $("div#promo-display.open").length==0)
       		CheckoutHelperJS.togglePromoCodeTab(promoDisplayButtonObj);
       }
       if(typeof(lazy_image_loader)!="undefined")
    	   lazy_image_loader(!0);
       petcoPersonalizationJS.isRxDetailsInCart();
			resetRequest(); 
			 		 var controller = this;
           var renderContext = this.renderContext;
           var toOrderidObj = dojo.byId("currentSFLOrderId");
           if(toOrderidObj != null && toOrderidObj.value != ""){
        	   if(dojo.byId("SaveForLaterContainer_id") != null && trim(dojo.byId("SaveForLaterContainer_id").innerHTML) == ""){
            	   dojo.byId("SaveForLaterContainer_id").innerHTML = CheckoutHelperJS.tempLabelForSFL();
               }else if(dojo.byId("SaveForLaterContainer_id") == null && dojo.byId('ShopCartPagingDisplayForSFL') != null && dojo.byId('WC_ShopCartDisplay_div_6') != null){
            	   var innerhtmlvalTemp  =dojo.byId('ShopCartPagingDisplayForSFL').innerHTML;
            		   var innerhtmlval = "";
            		   innerhtmlval = '<div id="tempCopyForEmptyCart_SFL">';
       			innerhtmlval = innerhtmlval+innerhtmlvalTemp;
       			innerhtmlval = innerhtmlval+'</div>';
            	   dojo.byId('ShopCartPagingDisplayForSFL').style.display = 'block';
            	   dojo.place(innerhtmlval, dojo.byId('WC_ShopCartDisplay_div_6'), 'last');
               }
        	   CheckoutHelperJS.cleanSFLBannerFromController();
        	   wc.render.updateContext('ShopCartPagingDisplayForSFL_Context',{'SFLItemOrderId':toOrderidObj.value});        	   
           }else{
        	   CheckoutHelperJS.affixTotalAmountDiv();
           }



           var isPromoCodeQualifiedMsg = document.getElementById("isPromoCodeQualified").value;
           $('#promo-reg-info').css({ display: "none" });
		   if((document.getElementById("newRedundantPromoCode")!= undefined || document.getElementById("newRedundantPromoCode") != null) && (document.getElementById("newBestPromoCodeApplied")!= undefined || document.getElementById("newBestPromoCodeApplied") != null)){
		   var previousBestPromoCode = document.getElementById("bestPromoCodeApplied").value;
			var bestPromoCode = document.getElementById("newBestPromoCodeApplied").value;
			var previousRedundantPromoCode = document.getElementById("redundantPromoCode").value;
			var redundantPromoCode = document.getElementById("newRedundantPromoCode").value;
			if("" != isPromoCodeQualifiedMsg){
				$('#promo-conflict').css({ display: "none" });
				$('#promo-reg-info').css({ display: "block" });
				document.getElementById("promo-reg-info").innerHTML = isPromoCodeQualifiedMsg;
			}else if((previousBestPromoCode == '')&&(redundantPromoCode==''))
			{
			$('#promo-conflict').css({ display: "none" });
			$('#promo-conflict-info').css({ display: "none" });
			document.getElementById("bestPromoCodeApplied").value = bestPromoCode;
			document.getElementById("redundantPromoCode").value = redundantPromoCode;
			}
			else if((previousBestPromoCode == bestPromoCode) &&(bestPromoCode !='') && (previousRedundantPromoCode != redundantPromoCode))
			{
			$('#promo-conflict').css({ display: "none" });
			$('#promo-conflict-info').css({ display: "block" });
			document.getElementById("bestPromoCodeApplied").value = bestPromoCode;
			document.getElementById("redundantPromoCode").value = redundantPromoCode;
			}
			else if((previousBestPromoCode != bestPromoCode)&&(bestPromoCode !='')&&(previousRedundantPromoCode != redundantPromoCode))
			{
				if($("#isAutoAppliedPromoCode").length > 0 &&
						"true" != $("#isAutoAppliedPromoCode").val() ){
					$('#promo-conflict').css({ display: "block" });
					$('#promo-conflict-info').css({ display: "none" });
				}
			document.getElementById("bestPromoCodeApplied").value = bestPromoCode;
			document.getElementById("redundantPromoCode").value = redundantPromoCode;
			}
			else
			{
			$('#promo-conflict').css({ display: "none" });
			$('#promo-conflict-info').css({ display: "none" });
			document.getElementById("bestPromoCodeApplied").value = bestPromoCode;
			document.getElementById("redundantPromoCode").value = redundantPromoCode;
			}
			if (document.getElementById("newBestPromoCodeApplied") != null) {
			    $('.collapse').on('hidden.bs.collapse', function() {
			        $(this).parent().find(".glyphicon-minus").removeClass("glyphicon-minus").addClass("glyphicon-plus");
			    }).on('shown.bs.collapse', function() {
			        $(this).parent().find(".glyphicon-plus").removeClass("glyphicon-plus").addClass("glyphicon-minus");
			    });
			}
			if (document.getElementById("newBestPromoCodeApplied").value != "") {
			    $('#promo-display').collapse('show');
			    $('.collapse').on('hidden.bs.collapse', function() {
			        $(this).parent().find(".glyphicon-minus").removeClass("glyphicon-minus").addClass("glyphicon-plus");
			    }).on('shown.bs.collapse', function() {
			        $(this).parent().find(".glyphicon-plus").removeClass("glyphicon-plus").addClass("glyphicon-minus");
			    });
			}				
		}else if("" != isPromoCodeQualifiedMsg){
			$('#promo-conflict').css({ display: "none" });
			$('#promo-reg-info').css({ display: "block" });
			document.getElementById("promo-reg-info").innerHTML = isPromoCodeQualifiedMsg;
		}
		   document.getElementById("isPromoCodeQualified").value = ""
	         if (typeof(savedOrdersJS) != null && typeof(savedOrdersJS) != 'undefined')
	         {
	        	 savedOrdersJS.isCurrentOrderPage(true);
	         }
              var controller = this;
              if(document.getElementById("discountDetailsSection")!=null )  {
                     document.getElementById("discountDetailsSection").style.display = "block";
              }
              if(document.getElementById("appliedPromotionCodes")!=null ) {
                     document.getElementById("appliedPromotionCodes").style.display = "block";
              }        
              $('input.smartsave').focusout(smartSaveOff);
			  $('input.smartsave').focus(smartSaveOn);	

			                if(!CheckoutHelperJS.isAjaxCheckOut()){
	              CheckoutHelperJS.setFieldDirtyFlag(false);
	              CheckoutHelperJS.initDojoEventListenerShoppingCartPage();		
              }

              var orderId = renderContext.properties["orderId"];
              if(document.getElementById("currentOrderId")) {
              	orderId = document.getElementById("currentOrderId").value;
              }
              ShipmodeSelectionExtJS.displaySavedShipmentTypeForOrder(orderId);
			  if(document.getElementById("OrderFirstItemId"))
			  {
				ShipmodeSelectionExtJS.orderItemId = document.getElementById("OrderFirstItemId").value;
			  }
			  dojo.query('div[id^="shoppingListScript_"]').forEach(function(node, index, nodelist){dojo.eval(node.innerHTML);});
			  if (dojo.byId('palsCodes') != null) {
							var palsCodes = dojo.byId('palsCodes').value;
							var palsArr = palsCodes.split(',');
							for ( var i = 0; i < palsArr.length; i++) {
								var code = palsArr[i].substring(4,
										palsArr[i].length);
								if (document.getElementsByName(code) != undefined) {
									var els = document.getElementsByName(code);
									for ( var j = 0; j < els.length; j++) {
										els[j].checked = true;
									}
								}
							}
							var isDonationItemPresent = document.getElementById('isDonationItemPresent').value;
							if("true" == isDonationItemPresent){
								var pal_Eligible_balance_amount = document.getElementById('pal_Eligible_balance_amount').value;
								if(pal_Eligible_balance_amount<5){
									dojo.forEach(dojo.query("div#pals_scenario1 input[type='checkbox']"),function(obj){if(!obj.checked){
									obj.disabled = true; dojo.addClass(obj.parentNode.parentNode,"text-muted")}
									});
									$('#palsAlert').css({ display: "block" });
								}else{
									dojo.forEach(dojo.query("div#pals_scenario1 input[type='checkbox']"),function(obj){
										obj.disabled = false;dojo.removeClass(obj.parentNode.parentNode,"text-muted")})
									$('#palsAlert').css({ display: "none" });
								}
							}
				}
			  cursor_clear();
			  var rmvCartValue = $("#RemovedCartCheck").val();
			  if(rmvCartValue != "No"){
				  var doNotShowUndoLink = false;
				  if(rmvCartValue.indexOf('isFreshPet:') > 0){
					  var isFreshPetStartingIdx = rmvCartValue.indexOf('isFreshPet:') + 11;
					  var isFreshPetItem = rmvCartValue.substring(isFreshPetStartingIdx, isFreshPetStartingIdx + 4);
					  if(isFreshPetItem != undefined && isFreshPetItem == "true"){
						  doNotShowUndoLink = true;
					  }
					  rmvCartValue = rmvCartValue.substring(0, rmvCartValue.indexOf('isFreshPet:') - 1);
					  if(rmvCartValue.indexOf('empty_removedOrderItemType') > 0){
						  rmvCartValue = rmvCartValue.substring(0, rmvCartValue.indexOf('empty_removedOrderItemType') - 1);
					  }
				  }

				  				  var rmvCartArr = rmvCartValue.split('|');
				  var innerhtml = "";
				  innerhtml=innerhtml+"<div class='row product-removed-row'>";
				  innerhtml=innerhtml+"<div class='alert alert-dismissable product-removed cart-product-removed-conatiner'>";
				  innerhtml=innerhtml+"<button type='button' onclick='Javascript:CheckoutHelperJS.removeBannerDismiss();' class='icon-modal-x' data-dismiss='alert'>close</button>";
				  innerhtml=innerhtml+"<strong>";
				  innerhtml=innerhtml+rmvCartArr[0];
				  innerhtml=innerhtml+"</strong> has been removed.";
				  if(!doNotShowUndoLink){
				  innerhtml=innerhtml+"<a class=\"remove\" href=\"Javascript:productDisplayJS.AddtoShopCartAjax(";
				  innerhtml=innerhtml+"'"+rmvCartArr[1]+"','"+rmvCartArr[2]+"','"+rmvCartArr[3]+"'";
				  innerhtml=innerhtml+", false,false)\"";
				  innerhtml=innerhtml+">Undo</a>";
				  }
				  innerhtml=innerhtml+"</div></div>";
				  console.log('Final-innerhtml-'+innerhtml);
				  if (document.getElementById("totalNumberOfItems") != null) {
				  	if(rmvCartArr[5]!= undefined){
					  	var rmvDiv = parseInt(rmvCartArr[5]);
					  	if(rmvDiv != 0){
					  		rmvDiv = rmvDiv-1;
					  	}
					  	if($('#removeCartUndo_'+rmvCartArr[4]+'_'+rmvDiv).length >0){
					  		document.getElementById('removeCartUndo_'+rmvCartArr[4]+'_'+rmvDiv).innerHTML = innerhtml;
					  	}else{
					  	 	var headHtml = "<section class=\"full-width cart-products-section\"><div class=\"border-bottom-thick full-width deliver-heading\">";
					  	 	if(rmvCartArr[4] == 'sameday')
						  	 	headHtml = headHtml+"<span class=\"icon-"+rmvCartArr[4]+"\" style=\"margin-top: -15px;\"></span><h4 class=\"float-left\">"+MessageHelper.messages[rmvCartArr[4]+"_HEADING"]+"</h4></div></section>";
							else if(rmvCartArr[4] == 'shipping')
						  	 	headHtml = headHtml+"<span class=\"icon-"+rmvCartArr[4]+"\"></span><h4 class=\"float-left padding-left-shipping\">"+MessageHelper.messages[rmvCartArr[4]+"_HEADING"]+"</h4></div></section>";					  	 	
						  	else
						  		headHtml = headHtml+"<span class=\"icon-"+rmvCartArr[4]+"\"></span><h4 class=\"float-left\">"+MessageHelper.messages[rmvCartArr[4]+"_HEADING"]+"</h4></div></section>";					  	 	
					  		document.getElementById("removeCartUndo_"+rmvCartArr[4]+"_last").innerHTML = headHtml+innerhtml;
					  	}
					 }else{
					 		var rmvDiv = document.getElementById("RemovedOrdCount").value; 
					 	 var curentDiv =  parseInt(document.getElementById("totalNumberOfItems").value)+1; 
				  		if (curentDiv != rmvDiv){
				  			if(null != document.getElementById("removeCartUndo_"+rmvDiv))
				  				document.getElementById("removeCartUndo_"+rmvDiv).innerHTML = innerhtml;
				  			else if(null != document.getElementById("removeCartUndo_last"))
				  				document.getElementById("removeCartUndo_last").innerHTML = innerhtml;				  			
				  		}
				  		else{
				  			if(null != document.getElementById("removeCartUndo_last"))
				  				document.getElementById("removeCartUndo_last").innerHTML = innerhtml;
				  			}
					 }


				  					  					  }
				  else{
					  if(null != document.getElementById("removeCartUndo"))
						  document.getElementById("removeCartUndo").innerHTML = innerhtml; 
				  }
				  if(null != document.getElementById("UndoValue"))
					  document.getElementById("UndoValue").value = "Yes";
				  if (document.getElementById('currencyContext') != null)
					var currencyContext = document.getElementById('currencyContext').value;
				  else
					var currencyContext = "USD"
				  loadMiniCart(currencyContext, "-1");				 
			  }
			  cursor_clear();

			  var isReflektionEnabled = $("#ENABLE_REFLEKTION");
			  var rfkWidgetId;     	  
			  if(isReflektionEnabled.length > 0 && (isReflektionEnabled.val() == 'true')) {  
				  $("input[name=rfkWidgetId]").each(function() {
					  rfkWidgetId = $(this).val();
					  ReflektionHelperJS.rfkRecommendation_init(rfkWidgetId);
				  });
			  } 

			  			  var isCitrusShopCartEnabled = $("#CITRUS_SHOP_CART_AD_ENABLED");
			  if(isCitrusShopCartEnabled.length > 0 && (isCitrusShopCartEnabled.val() == 'true')) { 
				  const newDiv = document.createElement("div");
				  newDiv.id = 'shopCart_Citrus_ad';
				  if(document.getElementsByClassName(document.getElementsByClassName("rfk_recommendation_wrapper")[0]))
				  {


					   					  					  document.getElementsByClassName("rfk_recommendation_wrapper")[0].after(newDiv);	
				  }
				  else if(document.getElementById("full-cart-block"))
				   {  
					   document.getElementById("full-cart-block").after(newDiv);		

					  				   }  
				   else if(document.getElementById("WC_ShopCartDisplay_div_6"))
				   {   
					   document.getElementById("WC_ShopCartDisplay_div_6").after(newDiv);		

					  				   }

				  				  CheckoutHelperJS.prepareCitrusAd(document.getElementById('citrusAdBnrSltId').value,document.getElementById('citrusAdCatalogId').value,document.getElementById('citrusAdContentStdId').value);	  
				  document.getElementById("shopCart_Citrus_ad").style.display='inline-block';	
			  }


			  var isCioEnabled = $("#ENABLE_CONSTRUCTORIO_RECOMMENDATION");
			  var rfkWidgetId;     	  
			  if(isCioEnabled.length > 0 && (isCioEnabled.val() == 'true')) {  
					  $("input[name=cioWidgetId]").each(function() {
						  rfkWidgetId = $(this).val();
						  ConstructorioHelperJS.cioRecommendation_initBatch(rfkWidgetId);
					  });			   
			  } 

			  if(document.getElementById("hasOOSLineItems")!= undefined || document.getElementById("hasOOSLineItems") != null){				  
				  var hasOOSLineItems = document.getElementById("hasOOSLineItems").value;
				  if(hasOOSLineItems == 'true'){
					  dojo.removeClass(dojo.byId('oosItemErrorDiv'),"hide");
					  dojo.addClass(dojo.byId('oosItemErrorDiv'),"");
				  } else{
					  dojo.addClass(dojo.byId('oosItemErrorDiv'),"hide");
				  }
			  }
			   if(document.getElementById("hasOOSBopusLineItems")!= undefined || document.getElementById("hasOOSBopusLineItems") != null){				  
				  var hasOOSBopusLineItems = document.getElementById("hasOOSBopusLineItems").value;
				  if(hasOOSBopusLineItems == 'true'){
					  dojo.removeClass(dojo.byId('oosBopusItemErrorDiv'),"hide");
					  dojo.addClass(dojo.byId('oosBopusItemErrorDiv'),"");
				  } else{
					  dojo.addClass(dojo.byId('oosBopusItemErrorDiv'),"hide");
				  }
			  }

			  if(document.getElementById("shipRestrictionFlagVariable")!= undefined || document.getElementById("shipRestrictionFlagVariable") != null){
				  var shipRestrictionFlagVariable = document.getElementById("shipRestrictionFlagVariable").value;
				  if(shipRestrictionFlagVariable == 'true'){
					  	dojo.removeClass(dojo.byId('shippingAddressErrorDiv'),"no-show");
					  	dojo.addClass(dojo.byId('shippingAddressErrorDiv'),"");
					}else{
					  	dojo.addClass(dojo.byId('shippingAddressErrorDiv'),"no-show");
					}
			  }
			   if(typeof(petcoCommonJS) != "undefined"){
	            	  petcoCommonJS.bopusCartEnableRadio();
	            	  petcoCommonJS.calculatedRDPrice();
	              }

			  if(document.getElementById("cartTagging")!= 'undefined' && document.getElementById("cartTagging") != null){
		    	   eval.call(window,document.getElementById("cartTagging").innerHTML);
				}

			  			  if (document.getElementById("HolidayShipMsgFlag") != null && document.getElementById("HolidayShipMsgFlag").value == 'Y') {
				  getShippingMessage(petcoCommonJS.storeId , petcoCommonJS.catalogId, petcoCommonJS.langId, 
						  dojo.byId('currentOrderIdShop').value, 'N', '', '');
			  }

			                petcoNearestLocations.fnUpdateBopusHeader();
              if(document.getElementById("toolTip_init")!= 'undefined' && document.getElementById("toolTip_init") != null){
	              var toolTip_init_script =  document.getElementById("toolTip_init");
	              if( toolTip_init_script != null){
	              	eval(toolTip_init_script.innerHTML);
	              }   
              }

              if(typeof(window._updateCartIndicatorAmount)=="function"){
            	  window._updateCartIndicatorAmount($('#currentOrderQuantityShop').val());
              }
              if(CheckoutHelperJS.isPromoCodeManullayAdded){
            	  var params = [];
                  params.storeId	= petcoCommonJS.storeId;
                  params.catalogId	= petcoCommonJS.catalogId;
                  params.langId		= petcoCommonJS.langId;
                  params.orderId	= document.getElementById("currentOrderId").value;
                  params.promoCode	= bestPromoCode;
                  wc.service.invoke("AjaxGetPromoExclusionMsg",params);
                  CheckoutHelperJS.isPromoCodeManullayAdded = false;
              }

                            if(document.getElementById("isPccEnabled") && document.getElementById("isPccEnabled") != null && document.getElementById("isPccEnabled").value === 'true'){
            	  if(document.getElementById("petco-pay-card") && document.getElementById("petco-pay-card") != null && (typeof EpJs !== 'undefined')){
            		  EpJs.generatePlacements();
            	  }
              }

                            if($("#klarnaInitScript").length > 0){
            	  var klarnaInitScript =  document.getElementById("klarnaInitScript");
            	  if( klarnaInitScript != null){
            		  eval(klarnaInitScript.innerHTML);
            	  }
              }

                            if($("#klarnaOSMScript").length > 0){
            	  window.KlarnaOnsiteService = window.KlarnaOnsiteService || []; 
            	  window.KlarnaOnsiteService.push({ eventName: 'refresh-placements' });
              }

       }
}),
wc.render.declareRefreshController({
       id: "ShopCartPaginationDisplayController",
       renderContext: wc.render.getContextById("ShopCartPaginationDisplay_Context"),
       url: "",
       formId: ""

       ,renderContextChangedHandler: function(message, widget) {

    	                 var controller = this;
              var renderContext = this.renderContext;
              if(controller.testForChangedRC(["beginIndex"])){
                     widget.refresh(renderContext.properties);
              }
       }

       ,postRefreshHandler: function(widget) {

    	                 var controller = this;
              var renderContext = this.renderContext;
              cursor_clear();
              if(!CheckoutHelperJS.isAjaxCheckOut()){
	              CheckoutHelperJS.setFieldDirtyFlag(false);
	              CheckoutHelperJS.initDojoEventListenerShoppingCartPage();
              }

              var orderId = renderContext.properties["orderId"];
              if(document.getElementById("currentOrderId")) {
              	orderId = document.getElementById("currentOrderId").value;
              }
              ShipmodeSelectionExtJS.displaySavedShipmentTypeForOrder(orderId);
              if(typeof(petcoCommonJS) != "undefined"){
            	  petcoCommonJS.bopusCartEnableRadio();
              }


                                   }
}),

wc.render.declareRefreshController({
       id: "AddToCartPagingDisplayController",
       renderContext: wc.render.getContextById("AddToCartPageDisplay_Context"),
       url: "",
       formId: ""

       ,renderContextChangedHandler: function(message, widget) {

    	                 var controller = this;
              var renderContext = this.renderContext;
              widget.refresh(renderContext.properties);
       }

       ,postRefreshHandler: function(widget) {
    	   if($('#rd-popover') != null && $('#rd-popover') != undefined){
    		   $('#rd-popover').popover({
	   				'html':true,
	   				'trigger':'hover',
	   				'content': $('#rd-popover-content').html(),
	   				'placement': 'top'
   				});
    	   }
    	   CheckoutHelperJS.invokeDeliveryDateAPI("cart");
    	   petcoPersonalizationJS.isRxDetailsInCart();
    	   petcoCommonJS.calculatedRDPrice();
       }
}),

wc.render.declareRefreshController({
      id: "PendingOrderPaginationDisplayController",
      renderContext: wc.render.getContextById("PendingOrderPaginationDisplay_Context"),
      url: "",
      formId: ""

      ,renderContextChangedHandler: function(message, widget) {
             var controller = this;
             var renderContext = this.renderContext;

                          if(controller.testForChangedRC(["beginIndex"])){
            	 widget.refresh(renderContext.properties);
             }
      }

      ,postRefreshHandler: function(widget) {

    	               var controller = this;
             var renderContext = this.renderContext;
             cursor_clear();
      }
}),

wc.render.declareRefreshController({
       id: "OrderItemPaginationDisplayController",
       renderContext: wc.render.getContextById("OrderItemPaginationDisplay_Context"),
       url: "",
       formId: ""

       ,renderContextChangedHandler: function(message, widget) {
              var controller = this;
              var renderContext = this.renderContext;
              if(controller.testForChangedRC(["beginIndex"])){
                     widget.refresh(renderContext.properties);
              }
       }

       ,postRefreshHandler: function(widget) {
              var controller = this;
              var renderContext = this.renderContext;
              cursor_clear();
       }
}),

wc.render.declareRefreshController({
    id: "PetcoOrderTotalSummaryController",
    renderContext: wc.render.getContextById("PetcoOrderTotalSummary_Context"),
    url: "",
    formId: ""

    ,renderContextChangedHandler: function(message, widget) {
           var controller = this;
           var renderContext = this.renderContext;
           widget.refresh(renderContext.properties);

               }

    ,postRefreshHandler: function(widget) {
           var controller = this;
           var renderContext = this.renderContext;
    }
}),

wc.render.declareRefreshController({
    id: "PetcoRepeatDeliveryEditItemController",
    renderContext: wc.render.getContextById("PetcoRepeatDeliveryEditItem_Context"),
    url: "",
    formId: ""

    ,renderContextChangedHandler: function(message, widget) {
           var controller = this;
           var renderContext = this.renderContext;
           widget.refresh(renderContext.properties);

               }

    ,postRefreshHandler: function(widget) {
           var controller = this;
           var renderContext = this.renderContext;
    }
}),

wc.render.declareRefreshController({
    id: "PetcoRepeatDeliveryEditItemRDPriceController",
    renderContext: wc.render.getContextById("PetcoRepeatDeliveryEditItemRDPrice_Context"),
    url: "",
    formId: ""

    ,renderContextChangedHandler: function(message, widget) {
           var controller = this;
           var renderContext = this.renderContext;
           widget.refresh(renderContext.properties);

               }

    ,postRefreshHandler: function(widget) {
           var controller = this;
           var renderContext = this.renderContext;
    }
}),

wc.render.declareRefreshController({
    id: "PetcoCancelRepeatDeliveryConfirmationController",
    renderContext: wc.render.getContextById("PetcoCancelRepeatDeliveryConfirmation_Context"),
    url: "",
    formId: ""

    ,renderContextChangedHandler: function(message, widget) {
           var controller = this;
           var renderContext = this.renderContext;
           widget.refresh(renderContext.properties);
           cursor_wait();

               }

    ,postRefreshHandler: function(widget) {
           var controller = this;
           var renderContext = this.renderContext;
           cursor_clear();
    }
}),

wc.render.declareRefreshController({
    id: "SSFSOrderItemPaginationDisplayController",
    renderContext: wc.render.getContextById("OrderItemPaginationDisplay_Context"),
    url: "",
    formId: ""

    ,renderContextChangedHandler: function(message, widget) {
           var controller = this;
           var renderContext = this.renderContext;
           if(controller.testForChangedRC(["beginIndex"])){
                  widget.refresh(renderContext.properties);
           }
    }

    ,postRefreshHandler: function(widget) {
           var controller = this;
           var renderContext = this.renderContext;

                                   var orderStr = document.getElementById("jsonOrderStr").innerHTML;
           var beginIndex = this.renderContext.properties['beginIndex'];
           var pageSize = this.renderContext.properties['pageSize'];             
           sterlingIntegrationJS.populateOrderLineInfoForSingleShipment(orderStr, beginIndex, pageSize);         	
           cursor_clear();
    }
}),

wc.render.declareRefreshController({
       id: "MSOrderItemPaginationDisplayController",
       renderContext: wc.render.getContextById("MSOrderItemPaginationDisplay_Context"),
       url: "",
       formId: ""

       ,renderContextChangedHandler: function(message, widget) {
              var controller = this;
              var renderContext = this.renderContext;
              if(controller.testForChangedRC(["beginIndex"])){
                     widget.refresh(renderContext.properties);
              }
       }

       ,postRefreshHandler: function(widget) {
              var controller = this;
              var renderContext = this.renderContext;
              cursor_clear();
       }
}),

wc.render.declareRefreshController({
    id: "SSFSMSOrderItemPaginationDisplayController",
    renderContext: wc.render.getContextById("MSOrderItemPaginationDisplay_Context"),
    url: "",
    formId: ""

    ,renderContextChangedHandler: function(message, widget) {
           var controller = this;
           var renderContext = this.renderContext;
           if(controller.testForChangedRC(["beginIndex"])){
                  widget.refresh(renderContext.properties);
           }
    }

    ,postRefreshHandler: function(widget) {
           var controller = this;
           var renderContext = this.renderContext;

                      var orderStr = document.getElementById("jsonOrderStr").innerHTML;
           var beginIndex = this.renderContext.properties['beginIndex'];
           var pageSize = this.renderContext.properties['pageSize'];              
           sterlingIntegrationJS.populateOrderLineInfoForMultipleShipment(orderStr, beginIndex, pageSize);              
           cursor_clear();
    }
}),

wc.render.declareRefreshController({
	id: "CouponDisplay_Controller",
	renderContext: wc.render.getContextById("CouponDisplay_Context"),
	url: "",
	formId: ""

	,modelChangedHandler: function(message, widget) {
		var controller = this;
		var renderContext = this.renderContext;
		if(message.actionId == 'AjaxCouponsAddRemove' || message.actionId == 'AjaxWalletItemProcessServiceDelete'){
			widget.refresh(renderContext.properties);
		}
	}
}),

wc.render.declareRefreshController({
    id: "PromotionFreeGifts_Controller",
    renderContext: wc.render.getContextById("PromotionFreeGifts_Context"),
    url: "",
    formId: ""

    ,modelChangedHandler: function(message, widget) {
           var controller = this;
           var renderContext = this.renderContext;
    }

    ,renderContextChangedHandler: function(message, widget) {
           var controller = this;
           var renderContext = this.renderContext;   
           widget.refresh(renderContext.properties);
    }

        ,postRefreshHandler: function(widget) {
	    var controller = this;
	    var renderContext = this.renderContext;	   
	    cursor_clear();
	    PromotionChoiceOfFreeGiftsJS.showFreeGiftsDialog();
   }
}),

wc.render.declareRefreshController({
       id: "ListOrdersDisplay_Controller",
       renderContext: wc.render.getContextById("ListOrdersDisplay_Context"),
       url: "",
       formId: ""

    	   ,modelChangedHandler: function(message, widget) {
           var controller = this;
           var renderContext = this.renderContext;
           if(message.actionId in listorders_changed){

	       	   	 	if ((message.actionId == 'AjaxOrderCreate' || message.actionId == 'AjaxSingleOrderCalculate') && this.renderContext.properties["startNumber"] != 0) 
	       	   	 	{

	       	   	 			       	   	 		wc.render.updateContext("ListOrdersDisplay_Context", {'startNumber' : 0});	
	       	   	 	}
	       	   	 	else
	       	   	 	{
	       	   	 		widget.refresh(renderContext.properties);
	       	   	 	}
           }
    }

       ,renderContextChangedHandler: function(message, widget) {
              var controller = this;

                          var renderContext = this.renderContext;
              if(controller.testForChangedRC(["startNumber"])){

            	            	  widget.refresh(renderContext.properties);
              }
       }

       ,postRefreshHandler: function(widget) {

        	              var controller = this;
              var renderContext = this.renderContext;
              if (savedOrdersJS.updateCurrentOrder)
              {
            	  savedOrdersJS.initializeCurrentOrder();
            	  savedOrdersJS.updateCurrentOrder = false;
              }
              savedOrdersJS.updateToolbar();
              savedOrdersJS.checkAllIfNeeded();
       }
}),

wc.render.declareRefreshController({
      id: "PendingOrderDisplayController",
      renderContext: wc.render.getContextById("PendingOrderPaginationDisplay_Context"),
      url: "",
      formId: ""

      ,modelChangedHandler: function(message, widget) {
             var controller = this;

                       var renderContext = this.renderContext;
             if(message.actionId in order_updated){

            	             	 	this.currentDesc = document.getElementById('OrderDescription_input').value;

            	 	                    widget.refresh(renderContext.properties);
             }
      }

      ,postRefreshHandler: function(widget) {
             var controller = this;

                        cursor_clear();

                          if (this.currentDesc != document.getElementById('OldOrderDescription').value)
             {
            	var inputElement = document.getElementById('OrderDescription_input');
            	if (inputElement != null && inputElement != 'undefined')
            	{
            		inputElement.value = this.currentDesc;
            		dojo.removeClass(inputElement, 'savedOrderDetailsInputBorder'); 
            		dojo.addClass(inputElement, 'savedOrderDetailsInputBorderWarning');
            	}
             }

                }

}),

wc.render.declareRefreshController({
       id: "BrowsingHistoryController",
       renderContext: wc.render.getContextById("BrowsingHistoryContext"),
       url: "",
       formId: ""

       ,renderContextChangedHandler: function(message, widget) {
		    var controller = this;
		    var renderContext = this.renderContext;

		    if(controller.testForChangedRC(["status"])){
		    	widget.refresh(renderContext.properties);
		    }	
       }

       ,postRefreshHandler: function(widget) {
        	if(!document.getElementById('WC_ScrollingProductsESpot_EmptyImgContainer_BrowsingHistory')){
        			document.getElementById('WC_LeftSidebarDisplay_div_5').style.display = 'block';
        	}
       }       

       }),

wc.render.declareRefreshController({
      id: "BrowsingHistoryDisplay_Controller",
      renderContext: wc.render.getContextById("BrowsingHistoryDisplay_Context"),
      url: "",
      formId: ""

       ,renderContextChangedHandler: function(message, widget) {
		    var controller = this;
		    var renderContext = this.renderContext;

		    if(controller.testForChangedRC(["currentPage"]) || controller.testForChangedRC(["pageView"])){
		    	widget.refresh(renderContext.properties);
		    }	
       }

       ,postRefreshHandler: function(widget) {
        	cursor_clear();
       }

}),

wc.render.declareRefreshController({
	id: "CategorySubscriptionController",
	renderContext: wc.render.getContextById("CategorySubscriptionContext"),
	url: "",
	formId: ""

	,modelChangedHandler: function(message, widget) {
		var controller = this;
		var renderContext = this.renderContext;
		if(message.actionId == "AjaxCategorySubscribe"){
			widget.refresh(renderContext.properties);
		}
	}

	,postRefreshHandler: function(widget) {
		cursor_clear();
		if(dojo.byId("CategorySubscriptionImage") == null){
			dojo.animateProperty({
				node: dojo.byId("CategorySubscriptionLink"),
				duration: 1500,
				properties: {
					backgroundColor: {
						start: "yellow",
						end: dojo.style("CategorySubscriptionLink", "backgroundColor")
					}
				}
			}).play();
		}
	}
}),

wc.render.declareRefreshController({
       id: "RecurringOrderDisplayController",
       renderContext: wc.render.getContextById("RecurringOrderDisplay_Context"),
       url: "",
       formId: ""


		,modelChangedHandler: function(message, widget) {
              var controller = this;
              var renderContext = this.renderContext;
              if (message.actionId == "AjaxCancelSubscription") {
                     controller.url = wc.render.getRefreshControllerById("RecurringOrderDisplayController").url;
                     widget.refresh(renderContext.properties);
              }
       }

       ,renderContextChangedHandler: function(message, widget) {
              var controller = this;
              var renderContext = this.renderContext;
              if(controller.testForChangedRC(["beginIndex"])){
            	  	widget.refresh(renderContext.properties);
              }
       }

       ,postRefreshHandler: function(widget) {
              var controller = this;
              var renderContext = this.renderContext;
              cursor_clear();
       }
}),



wc.render.declareRefreshController({
       id: "RepeatOrderDisplayController",
       renderContext: wc.render.getContextById("RepeatOrderDisplay_Context"),
       url: "",
       formId: ""


		,renderContextChangedHandler: function(message, widget) {

    	   	          var controller = this;
              var renderContext = this.renderContext;

                           if(controller.testForChangedRC(["beginIndex"])){

            	  	                     widget.refresh(renderContext.properties);
              }
       }

       ,postRefreshHandler: function(widget) {

    	         		$('#datepicker').datepicker({
    			inline: true,
    			language: 'en'
    		});

    	       	   dojo.query('script[id^="showRdDivID"]').forEach(function(node, index, nodelist){dojo.eval(node.innerHTML);});

       }
}),

wc.render.declareRefreshController({
       id: "MembershipOrderDisplayController",
       renderContext: wc.render.getContextById("MembershipOrderDisplay_Context"),
       url: "",
       formId: ""


		,renderContextChangedHandler: function(message, widget) {

    	   	          var controller = this;
              var renderContext = this.renderContext;

                           if(controller.testForChangedRC(["beginIndex"])){

            	  	                     widget.refresh(renderContext.properties);
              }
       }

       ,postRefreshHandler: function(widget) {

    	         		$('#datepicker').datepicker({
    			inline: true,
    			language: 'en'
    		});

    	       	   dojo.query('script[id^="showMembershipDivID"]').forEach(function(node, index, nodelist){dojo.eval(node.innerHTML);});

       }
}),

wc.render.declareRefreshController({
       id: "SubscriptionDisplayController",
       renderContext: wc.render.getContextById("SubscriptionDisplay_Context"),
       url: "",
       formId: ""


		,modelChangedHandler: function(message, widget) {
              var controller = this;
              var renderContext = this.renderContext;
              if (message.actionId == "AjaxCancelSubscription") {
                     controller.url = wc.render.getRefreshControllerById("SubscriptionDisplayController").url;
                     widget.refresh(renderContext.properties);
              }
       }

       ,renderContextChangedHandler: function(message, widget) {
              var controller = this;
              var renderContext = this.renderContext;
              if(controller.testForChangedRC(["beginIndex"])){
                     widget.refresh(renderContext.properties);
              }
       }

       ,postRefreshHandler: function(widget) {
              var controller = this;
              var renderContext = this.renderContext;
              cursor_clear();
       }
}),

wc.render.declareRefreshController({
       id: "RecentRecurringOrderDisplayController",
       renderContext: wc.render.getContextById("RecentRecurringOrderDisplay_Context"),
       url: "",
       formId: ""


		,modelChangedHandler: function(message, widget) {
              var controller = this;
              var renderContext = this.renderContext;
              if (message.actionId == "AjaxCancelSubscription") {
                     controller.url = wc.render.getRefreshControllerById("RecurringOrderDisplayController").url;
                     widget.refresh(renderContext.properties);
              }
       }

       ,postRefreshHandler: function(widget) {
              var controller = this;
              var renderContext = this.renderContext;
              cursor_clear();
       }
}),

wc.render.declareRefreshController({
       id: "RecentSubscriptionDisplayController",
       renderContext: wc.render.getContextById("RecentSubscriptionDisplay_Context"),
       url: "",
       formId: ""


		,modelChangedHandler: function(message, widget) {
              var controller = this;
              var renderContext = this.renderContext;
              if (message.actionId == "AjaxCancelSubscription") {
                     controller.url = wc.render.getRefreshControllerById("SubscriptionDisplayController").url;
                     widget.refresh(renderContext.properties);
              }
       }

       ,postRefreshHandler: function(widget) {
              var controller = this;
              var renderContext = this.renderContext;
              cursor_clear();
       }
}),

wc.render.declareRefreshController({
       id: "RecurringOrderChildOrdersDisplayController",
       renderContext: wc.render.getContextById("RecurringOrderChildOrdersDisplay_Context"),
       url: "",
       formId: ""

       ,renderContextChangedHandler: function(message, widget) {
              var controller = this;
              var renderContext = this.renderContext;
              if(controller.testForChangedRC(["beginIndex"])){
                     widget.refresh(renderContext.properties);
              }
       }

       ,postRefreshHandler: function(widget) {
              var controller = this;
              var renderContext = this.renderContext;
              cursor_clear();
       }
}),

wc.render.declareRefreshController({
       id: "SubscriptionChildOrdersDisplayController",
       renderContext: wc.render.getContextById("SubscriptionChildOrdersDisplay_Context"),
       url: "",
       formId: ""

       ,renderContextChangedHandler: function(message, widget) {
              var controller = this;
              var renderContext = this.renderContext;
              if(controller.testForChangedRC(["beginIndex"])){
                     widget.refresh(renderContext.properties);
              }
       }

       ,postRefreshHandler: function(widget) {
              var controller = this;
              var renderContext = this.renderContext;
              cursor_clear();
       }
}),

wc.render.declareRefreshController({
	id: "QuickInfoDetailsController",
	renderContext: wc.render.getContextById("QuickInfoContext"),
	url: "",
	formId: "",
	quickInfoEvenSubscribed: false,
	renderContextChangedHandler: function(message, widget) {
		if(!submitRequest()){
			return;
		}
		cursor_wait();
		widget.refresh(this.renderContext.properties);			
	},

	postRefreshHandler: function(widget) {
		if(dojo.byId("QuickInfostoreParams")){
			var storeParams = dojo.byId("QuickInfostoreParams").value;
			if(dojo.byId("catEntryParamsForJS")){
				var catEntryParams = dojo.byId("catEntryParamsForJS").value;
			}
			var shoppingListNames = dojo.byId("QuickInfoshoppingListNames").value;

						shoppingListJSQuickInfo = new ShoppingListJS(dojo.fromJson(storeParams), dojo.fromJson(catEntryParams), dojo.fromJson(shoppingListNames),"shoppingListJSQuickInfo");


									if (! this.quickInfoEvenSubscribed){
				this.quickInfoEvenSubscribed = true;
				dojo.topic.subscribe("DefiningAttributes_Resolved", function(catEntryId, productId) {
					shoppingListJSQuickInfo.setItemId(catEntryId, productId);
				});
				dojo.topic.subscribe("QuickInfo_attributesChanged", function(catEntryAttributes) {
					shoppingListJSQuickInfo.setCatEntryAttributes(catEntryAttributes);
				});
				dojo.topic.subscribe("Quantity_Changed", function(catEntryQuantityObject) {
					shoppingListJSQuickInfo.setCatEntryQuantity(catEntryQuantityObject);
				});
				dojo.topic.subscribe("ShoppingList_Changed", function(serviceResponse) {
					shoppingListJSQuickInfo.updateShoppingListAndAddItem(serviceResponse);
				});
				dojo.topic.subscribe("ShoppingListItem_Added", function() {
					shoppingListJSQuickInfo.deleteItemFromCart();
				});
				dojo.connect(dojo.byId("QuickInfoaddToShoppingListDropdown"),"onmouseover", function(){
					shoppingListJSQuickInfo.mouseOnArrow = true;
				});
				dojo.connect(dojo.byId("QuickInfoShoppingList_0"),"onmouseover", function(){
					shoppingListJSQuickInfo.exceptionFlag = true; document.getElementById('QuickInfoShoppingListLink_0').focus();
				});	
			}

						var catEntryId = dojo.fromJson(catEntryParams).id;
			if(null != catEntryId && '' != catEntryId){
				wc.render.updateContext('QuickInfoDiscountDetailsContext', {productId:dojo.fromJson(catEntryParams).id});
			}
		}
		if(dojo.byId("catEntryParamsForJS")){
			QuickInfoJS.catEntryParams = dojo.fromJson(dojo.byId('catEntryParamsForJS').value);
		}

					if(QuickInfoJS.itemId == ''){
				QuickInfoJS.setCatEntryQuantity(1);
				QuickInfoJS.selectDefaultSwatch();
			} else {
				QuickInfoJS.selectCurrentAttributes();
			}

						if(document.getElementById('notifyCaptcha') != null){
				  var string = "'"+document.getElementById('captchaKey').value+"'";
			  	  notifyWidget = grecaptcha.render(document.getElementById('notifyCaptcha'),{'sitekey' : string});
			}

						$("#quickbuy").modal('show');
			cursor_clear();
			activateRatings();
			dojo.query('script[id^="QuickInfo_Inventory_"]').forEach(function(node, index, nodelist){dojo.eval(node.innerHTML);});
			dojo.query('script[id^="QuickInfo_Add2Cart_"]').forEach(function(node, index, nodelist){dojo.eval(node.innerHTML);});
			if (ios || android) {
				quickInfoPopup._relativePosition = new Object();
			}

			QuickInfoJS.preSelectRadioButtonOnQuickInfo();


						} 
}),

wc.render.declareRefreshController({
	id: "DiscountDetailsController",
	renderContext: wc.render.getContextById("DiscountDetailsContext"),
	url: "DiscountDetailsView",
	formId: "",

	renderContextChangedHandler: function(message, widget) {
		widget.refresh(this.renderContext.properties);			
	},

	postRefreshHandler: function(widget) {
		cursor_clear();
	} 
}),
wc.render.declareRefreshController({
       id: "WishlistDisplayController",
       renderContext: wc.render.getContextById("MylistsDisplay_Context"),
       url: "",
       formId: ""

    	       	   ,modelChangedHandler: function(message, widget) {
			var controller = this;
	   		var renderContext = this.renderContext;
	   		widget.refresh(renderContext.properties);
	   	}

		,renderContextChangedHandler: function(message, widget) {

    	                 var controller = this;
              var renderContext = this.renderContext;
              widget.refresh(renderContext.properties);            
       }

       ,postRefreshHandler: function(widget) {
    	   AccountWishListDisplay.fetchInventoryDetailsForAllTheProducts("WishList");
    	   try{
    		   if(typeof(alter_Twitter_Url) != "undefined" && typeof(alter_Twitter_Url) == "function"){
    			   alter_Twitter_Url();
    	   		}
    	   }catch (err) {
   				console.log("alter Twitter Url Error"+err);
   		   } 
    	   dojo.query('script[id^="wishListCount_"]').forEach(function(node, index, nodelist){dojo.eval(node.innerHTML);});
    	   dojo.query('script[id^="shopListJSOnload_"]').forEach(function(node, index, nodelist){dojo.eval(node.innerHTML);});
    	   $('html,body').animate({scrollTop:$('#myWishList').position().top}, 'fast');

    	   onloadCallback();
       }
}),
wc.render.declareRefreshController({
       id: "PurchaselistDisplayController",
       renderContext: wc.render.getContextById("PurchaselistDisplay_Context"),
       url: "",
       formId: ""




		,renderContextChangedHandler: function(message, widget) {
              var controller = this;
              var renderContext = this.renderContext;

                            if(controller.testForChangedRC(["startIndex"])){
            	  widget.refresh(renderContext.properties);
              }
       }

       ,postRefreshHandler: function(widget) {
    	   AccountWishListDisplay.fetchInventoryDetailsForAllTheProducts("PurchaseList");
    	   if(typeof(alter_Twitter_Url) != "undefined" && typeof(alter_Twitter_Url) == "function"){
    		   alter_Twitter_Url();
    	   }
    	   var dropdown = dojo.byId('purchaseDate_div');

    	       	   dojo.query('script[id^="datetimepicker"]').forEach(function(node, index, nodelist){dojo.eval(node.innerHTML);});
    	   dojo.query('script[id^="purchaseListCount_"]').forEach(function(node, index, nodelist){dojo.eval(node.innerHTML);});
    	   dojo.query('script[id^="shopListJSOnloadForPurList_"]').forEach(function(node, index, nodelist){dojo.eval(node.innerHTML);});
    	   $('html,body').animate({scrollTop:$('#myPurchaseList').position().top}, 'fast');

    	         }
}),
wc.render.declareRefreshController({
	id: "QuickInfoDiscountDetailsController",
	renderContext: wc.render.getContextById("QuickInfoDiscountDetailsContext"),
	url: "DiscountDetailsView",
	formId: "",

	renderContextChangedHandler: function(message, widget) {
		widget.refresh(this.renderContext.properties);			
	},

	postRefreshHandler: function(widget) {
		cursor_clear();
	} 
}),

wc.render.declareRefreshController({
	id: "DoubleContentAreaESpot_Controller",
	renderContext: wc.render.getContextById("DoubleContentAreaESpot_Context"),
	url: "",
	formId: "",

	renderContextChangedHandler: function(message, widget) {
		if(this.testForChangedRC(["emsName"])){
			widget.refresh(this.renderContext.properties);	
		}
	},

	postRefreshHandler: function(widget) {
		cursor_clear();
	} 
}),

wc.render.declareRefreshController({
	id: "ScrollableESpot_Controller",
	renderContext: wc.render.getContextById("ScrollableESpot_Context"),
	url: "",
	formId: "",

	renderContextChangedHandler: function(message, widget) {
		if(this.testForChangedRC(["emsName"])){
			widget.refresh(this.renderContext.properties);
		}
	},

	postRefreshHandler: function(widget) {
		cursor_clear();
	} 
}),

wc.render.declareRefreshController({
	id: "TopCategoriesESpot_Controller",
	renderContext: wc.render.getContextById("TopCategoriesESpot_Context"),
	url: "",
	formId: "",

	renderContextChangedHandler: function(message, widget) {
		if(this.testForChangedRC(["emsName"])){
			widget.refresh(this.renderContext.properties);
		}
	},

	postRefreshHandler: function(widget) {
		cursor_clear();
	} 
}),

wc.render.declareRefreshController({
	id: "CategoryFeaturedProductsESpot_Controller",
	renderContext: wc.render.getContextById("CategoryFeaturedProductsESpot_Context"),
	url: "",
	formId: "",

	renderContextChangedHandler: function(message, widget) {
		if(this.testForChangedRC(["emsName"])){
			widget.refresh(this.renderContext.properties);
		}
	},

	postRefreshHandler: function(widget) {
		cursor_clear();
	} 
}),

wc.render.declareRefreshController({
	id: "HomeHeroESpot_Controller",
	renderContext: wc.render.getContextById("HomeHeroESpot_Context"),
	url: "",
	formId: "",

	renderContextChangedHandler: function(message, widget) {
		if(this.testForChangedRC(["emsName"])){
			widget.refresh(this.renderContext.properties);
		}
	},

	postRefreshHandler: function(widget) {
		cursor_clear();
	} 
}),

wc.render.declareRefreshController({
	id: "HomeLeftESpot_Controller",
	renderContext: wc.render.getContextById("HomeLeftESpot_Context"),
	url: "",
	formId: "",

	renderContextChangedHandler: function(message, widget) {
		if(this.testForChangedRC(["emsName"])){
			widget.refresh(this.renderContext.properties);
		}
	},

	postRefreshHandler: function(widget) {
		cursor_clear();
	} 
}),

wc.render.declareRefreshController({
	id: "HomeRightTopESpot_Controller",
	renderContext: wc.render.getContextById("HomeRightTopESpot_Context"),
	url: "",
	formId: "",

	renderContextChangedHandler: function(message, widget) {
		if(this.testForChangedRC(["emsName"])){
			widget.refresh(this.renderContext.properties);
		}
	},

	postRefreshHandler: function(widget) {
		cursor_clear();
	} 
}),

wc.render.declareRefreshController({
	id: "HomeRightBottomESpot_Controller",
	renderContext: wc.render.getContextById("HomeRightBottomESpot_Context"),
	url: "",
	formId: "",

	renderContextChangedHandler: function(message, widget) {
		if(this.testForChangedRC(["emsName"])){
			widget.refresh(this.renderContext.properties);
		}
	},

	postRefreshHandler: function(widget) {
		cursor_clear();
	} 
}),

wc.render.declareRefreshController({
	id: "TallDoubleContentAreaESpot_Controller",
	renderContext: wc.render.getContextById("TallDoubleContentAreaESpot_Context"),
	url: "",
	formId: "",

	renderContextChangedHandler: function(message, widget) {
		if(this.testForChangedRC(["emsName"])){
			widget.refresh(this.renderContext.properties);
		}
	},

	postRefreshHandler: function(widget) {
		cursor_clear();
	} 
}),

wc.render.declareRefreshController({
	id: "TopCategoryHeroESpot_Controller",
	renderContext: wc.render.getContextById("TopCategoryHeroESpot_Context"),
	url: "",
	formId: "",

	renderContextChangedHandler: function(message, widget) {
		if(this.testForChangedRC(["emsName"])){
			widget.refresh(this.renderContext.properties);
		}
	},

	postRefreshHandler: function(widget) {
		cursor_clear();
	} 
}),

wc.render.declareRefreshController({
	id: "TopCategoryTallDoubleESpot_Controller",
	renderContext: wc.render.getContextById("TopCategoryTallDoubleESpot_Context"),
	url: "",
	formId: "",

	renderContextChangedHandler: function(message, widget) {
		if(this.testForChangedRC(["emsName"])){
			widget.refresh(this.renderContext.properties);
		}
	},

	postRefreshHandler: function(widget) {
		cursor_clear();
	} 
}),

wc.render.declareRefreshController({
	id: "AttachmentPagination_Controller",
	renderContext: wc.render.getContextById("AttachmentPagination_Context"),
	url: "",
	formId: "",

	renderContextChangedHandler: function(message, widget) {
		if(this.testForChangedRC(["beginIndex"])){
			widget.refresh(this.renderContext.properties);
		}
	},

	postRefreshHandler: function(widget) {
		var pagesList = document.getElementById("pages_list_id");
		if (pagesList != null && !isAndroid() && !isIOS()) {
			dojo.addClass(pagesList, "desktop");
		}
		cursor_clear();
	} 
}),
wc.render.declareRefreshController({
	id: "rxPersonilaztionDisplayController",
	renderContext: wc.render.getContextById("rxPersonilaztionDisplayContext"),
	url: "",
	formId: "",
	renderContextChangedHandler: function(message, widget) {
		var controller = this;
		var renderContext = this.renderContext;
		widget.refresh(renderContext.properties);
  	},  
  postRefreshHandler: function(widget) {

	  	  $('[id^="quantity_"]').each(function(i,obj){
		  if($("#topCategoryValuePetType").length > 0 && $("#topCategoryValuePetType").val().trim() != ""){
			 	petcoPersonalizationJS.loadPetBreedValues("rxMedicinePetType_"+(i+1),"rxMedicinePetBreed_"+(i+1),null,petcoPersonalizationJS.getDefaultPetType().toUpperCase());
			  }else{
			 	 petcoPersonalizationJS.loadPetBreedValues("rxMedicinePetType_"+(i+1),"rxMedicinePetBreed_"+(i+1));
			  }

	  })


	  	   	var controller = this;
	var renderContext = this.renderContext;
	var quantity = controller.renderContext.properties["quantity"];	
	if( document.getElementById("form-modal-screen") != null &&
			document.getElementById("form-modal-screen").style.display == "block"){
		petcoCommonJS.showModal("modal-rxmedicine");
		$('#rxPersonilaztionDisplay').addClass('active');
	}

	if(undefined != document.getElementById("modal-rxmedicine") ){
		if(CheckoutHelperJS != undefined && CheckoutHelperJS.isshowpersonalizationPopup){
			petcoCommonJS.showModal("modal-rxmedicine");
			$('#rxPersonilaztionDisplay').addClass('active');
		}

				setTimeout(function(){
		  	if(document.getElementById("personalization") != null && document.getElementById("personalization").value == 'true'){
				if(typeof(localStorageHelper) != "undefined"){
					nextRepeatedDeliveryDateCookieValue = localStorageHelper.get("isWhishListButtonClicked",false);
					if(nextRepeatedDeliveryDateCookieValue == 'yes'){
						if(dojo.byId("addToShoppingList") != null){
							eval(dojo.getAttr("addToShoppingList","href"));
						}
						productDisplayJS.addtoWIshListClickedRemoved();
					}
				}
			}
	},1000);
	}
if(controller.renderContext.properties["persAttr"] != ""){
	petcoPersonalizationJS.reAssignRxPersonalizedAttr(controller.renderContext.properties["persAttr"]);	
}
	if(petcoPersonalizationJS.isloadedPetAndVetInfoInModel){
		dojo.topic.publish('loadPetAndVetInfoInModelLoaded', false);
	}else{
		dojo.topic.publish('loadPetAndVetInfoInModelLoaded', true);
	}
	petcoPersonalizationJS.isloadedPetAndVetInfoInModel = true;

  }
}),
wc.render.declareRefreshController({
	id: "personilaztionDisplayController",
	renderContext: wc.render.getContextById("personilaztionDisplayContext"),
	url: "",
	formId: ""

	,modelChangedHandler: function(message, widget) {
		var controller = this;
		var renderContext = this.renderContext;

		if(message.actionId == 'AjaxPetcoSendProductEmail' || message.actionId == 'AjaxOrderItemPersonalizationUpdate' ){
		}
	},
	renderContextChangedHandler: function(message, widget) {
			var controller = this;
		var renderContext = this.renderContext;
		widget.refresh(renderContext.properties);
  	},

    postRefreshHandler: function(widget) {
  	var controller = this;
	var renderContext = this.renderContext;
	var quantity = controller.renderContext.properties["quantity"];	
	var maxUserInputQuantity =  controller.renderContext.properties["maxUserInputQuantity"];
	if(quantity>maxUserInputQuantity){
		if(document.getElementById("maxUserInputQuantity")!=null)
			document.getElementById("maxUserInputQuantity").value = quantity;
	}else{
		if(document.getElementById("maxUserInputQuantity")!=null)
			document.getElementById("maxUserInputQuantity").value = maxUserInputQuantity;
	}


		if( document.getElementById("form-modal-screen") != null &&
			document.getElementById("form-modal-screen").style.display == "block"){
		if(document.getElementById("modal-zipcodeLocation") != null && document.getElementById("modal-zipcodeLocation").style.display != "block"){
		   petcoCommonJS.showModal("Personalization");
		   $('#personilaztionDisplay').addClass('active');
		}
	}

		if(undefined != document.getElementById("modal-Personalization") ){
		if(CheckoutHelperJS != undefined && CheckoutHelperJS.isshowpersonalizationPopup){
			console.log("testpurpose:commonControllersDeclaration.js:2528");
			petcoCommonJS.showModal("Personalization");
			$('#personilaztionDisplay').addClass('active');
		}

				setTimeout(function(){
			  	if(document.getElementById("personalization") != null && document.getElementById("personalization").value == 'true'){
					if(typeof(localStorageHelper) != "undefined"){
						nextRepeatedDeliveryDateCookieValue = localStorageHelper.get("isWhishListButtonClicked",false);
						if(nextRepeatedDeliveryDateCookieValue == 'yes'){
							if(dojo.byId("addToShoppingList") != null){
								eval(dojo.getAttr("addToShoppingList","href"));
							}
							productDisplayJS.addtoWIshListClickedRemoved();
						}
					}
				}
		},1000);


			}
	if ('isInCart' in renderContext.properties && renderContext.properties.isInCart) {
		dojo.forEach(dojo.query('div[id="cart-submit-button"]'),function(obj){
			obj.className = "col-8 col-center show";
		})
		dojo.forEach(dojo.query('div[id="pdp-submit-button"]'),function(obj){
				obj.className = "col-8 col-center hide";
		})
		dojo.forEach(dojo.query('div[id="wishList-submit-button"]'),function(obj){
			obj.className = "col-8 col-center hide";
		})

			}
	if(controller.renderContext.properties["persAttr"] != null && controller.renderContext.properties["persAttr"] != ""){

			petcoPersonalizationJS.reAssignPersonalizedAttr(controller.renderContext.properties["persAttr"]);	
	}

		if(dojo.byId("previousQuantity") != null && dojo.byId("personalizePaging") != null  && dojo.byId("isLTLDeliveryRequired") != null && dojo.byId("PersonalizationCheckBox_1") != null){
		if (dojo.byId("isLTLDeliveryRequired") && dojo.byId("isLTLDeliveryRequired").value == "true"){
			dojo.byId("PersonalizationCheckBox_1").checked = true;
			dojo.byId("PersonalizationCheckBox_1").parentNode.style.display = 'none';
			dojo.byId("personalizePaging").style.display = 'none';			
		}

		}
  }
}),

wc.render.declareRefreshController({
	id: "departmentDisplayController",
	renderContext: wc.render.getContextById("departmentContext"),
	url: "",
	formId: ""

		,modelChangedHandler: function(message, widget) {
		var controller = this;
		var renderContext = this.renderContext;

				 if(message.actionId  != "pingPetcoUserTypeAction"){
		widget.refresh(renderContext.properties);

			 }

	},
	renderContextChangedHandler: function(message, widget) {
		var controller = this;
		var renderContext = this.renderContext;
		widget.refresh(renderContext.properties);
  	},


	       		postRefreshHandler: function(widget) {
  		var controller = this;
  		var renderContext = this.renderContext;


  		  			  	} 
}),

wc.render.declareRefreshController({
	id: "subDepartmentDisplayController",
	renderContext: wc.render.getContextById("subDepartmentContext"),
	url: "",
	formId: ""

		,modelChangedHandler: function(message, widget) {
		var controller = this;
		var renderContext = this.renderContext;
		 if(message.actionId  != "pingPetcoUserTypeAction"){
		widget.refresh(renderContext.properties);

			 }


			},
	renderContextChangedHandler: function(message, widget) {
		var controller = this;
		var renderContext = this.renderContext;
		widget.refresh(renderContext.properties);
  	},


	       		postRefreshHandler: function(widget) {
  		var controller = this;
  		var renderContext = this.renderContext;
  	} 
}),
wc.render.declareRefreshController({
	id: "typeDisplayController",
	renderContext: wc.render.getContextById("typeContext"),
	url: "",
	formId: ""

		,modelChangedHandler: function(message, widget) {

			var controller = this;
		var renderContext = this.renderContext;

				 if(message.actionId  != "pingPetcoUserTypeAction"){
		widget.refresh(renderContext.properties);

			 }

			},
	renderContextChangedHandler: function(message, widget) {
		var controller = this;
		var renderContext = this.renderContext;
		widget.refresh(renderContext.properties);
  	},


	       		postRefreshHandler: function(widget) {
  		var controller = this;
  		var renderContext = this.renderContext;

  		  	} 
}),

wc.render.declareRefreshController({
	id: "contentSearchController",
	renderContext: wc.render.getContextById("contentSearchContext"),
	url: "",
	formId: ""

		,modelChangedHandler: function(message, widget) {

			var controller = this;
		var renderContext = this.renderContext;
	},
	renderContextChangedHandler: function(message, widget) {
		var controller = this;
		var renderContext = this.renderContext;
		widget.refresh(renderContext.properties);
  	},


	       		postRefreshHandler: function(widget) {
  		var controller = this;
  		var renderContext = this.renderContext;

  		  	} 
}),
wc.render.declareRefreshController({
	id: "eventDisplayController",
	renderContext: wc.render.getContextById("eventContext"),
	url: "",
	formId: ""

		,modelChangedHandler: function(message, widget) {
		var controller = this;
		var renderContext = this.renderContext;
		 if(message.actionId  != "pingPetcoUserTypeAction"){
		widget.refresh(renderContext.properties);

			 }

			},
	renderContextChangedHandler: function(message, widget) {
		var controller = this;
		var renderContext = this.renderContext;
		widget.refresh(renderContext.properties);
  	},


	       		postRefreshHandler: function(widget) {
  		var controller = this;
  		var renderContext = this.renderContext;


  		  			  	} 
}),
wc.render.declareRefreshController({
	id: "petBreedOptionsController",
	renderContext: wc.render.getContextById("petBreedOptionsContext"),
	url: "",
	formId: ""

		,modelChangedHandler: function(message, widget) {
		var controller = this;
		var renderContext = this.renderContext;

				 if(message.actionId  != "pingPetcoUserTypeAction"){
		widget.refresh(renderContext.properties);

			 }
	},
	renderContextChangedHandler: function(message, widget) {
		var controller = this;
		var renderContext = this.renderContext;
		widget.refresh(renderContext.properties);
  	},  
	postRefreshHandler: function(widget) {
  		var controller = this;
  		var renderContext = this.renderContext;
  	} 
}),

wc.render.declareRefreshController({
	id: "PetcoDonationItemsDisplayAreaController",
	renderContext: wc.render.getContextById("PetcoDonationItemsDisplay_Context"),
	url: "",
	formId: ""

	,renderContextChangedHandler: function(message, widget) {
		var controller = this;
		var renderContext = this.renderContext;
		widget.refresh(renderContext.properties);
  	},  
	postRefreshHandler: function(widget) {
  		var controller = this;
  		var renderContext = this.renderContext;
  		if(dojo.hasClass(dojo.byId("donationDisplayArea"),"field-listing-visible")){
  			dojo.forEach(dojo.query("ul#donationDisplayArea li.form-field-sublist"),function(obj){obj.style.display="block";});
  		}
  		else{
  			dojo.forEach(dojo.query("ul#donationDisplayArea li.form-field-sublist"),function(obj){obj.style.display="none";});
  		}
  		var donationAttrName= dojo.byId('donation_attr_name').value;
  		var donationFirstAttr= dojo.byId('donation_first_attr_value').value;
  		var donationCatentryId= dojo.byId('donation_catentry_id').value;
  		shoppingActionsJS.setSelectedAttribute(donationAttrName,donationFirstAttr, "entitledItem_"+donationCatentryId);
		shoppingActionsJS.changeDescription("entitledItem_"+donationCatentryId,donationFirstAttr);
  	} 
}),

wc.render.declareRefreshController({
       id: "ShopCartPaginationDisplayForSFLController",
       renderContext: wc.render.getContextById("ShopCartPagingDisplayForSFL_Context"),
       url: "",
       formId: ""




       ,renderContextChangedHandler: function(message, widget) {
              var controller = this;
              var renderContext = this.renderContext;
                     widget.refresh(renderContext.properties);
                     cursor_wait();

                            },

       postRefreshHandler: function(widget) {
    	   dojo.destroy('tempCopyForEmptyCart_SFL');
    	   var controller = this;
              var renderContext = this.renderContext;
            setTimeout(function(){CheckoutHelperJS.copyBackSaveForLater();CheckoutHelperJS.loadBannerForSaveForlater();},5);
            setTimeout(function(){CheckoutHelperJS.affixTotalAmountDiv();},200); 
              cursor_clear();
              petcoPersonalizationJS.isRxDetailsInCart();  
       }

}),
wc.render.declareRefreshController({
    id: "petcoWishListForRegController",
    renderContext: wc.render.getContextById("petcoWishListForReg_Context"),
    url: "",
    formId: ""
    ,renderContextChangedHandler: function(message, widget) {
           var controller = this;
           var renderContext = this.renderContext;
                  widget.refresh(renderContext.properties);
    },
    postRefreshHandler: function(widget) {
    	var jsToExecute = dojo.byId("javascriptOnloadGiftList");
    	if(jsToExecute != null){
    		eval(jsToExecute.innerHTML);
    	}
    	if(typeof(isPetcoWishListForRegCalled) != "undefined"){
			isPetcoWishListForRegCalled = false;
		}


  	    	      	if(document.getElementById("personalization") == null || 
      			(document.getElementById("personalization") != null && document.getElementById("personalization").value != 'true')){
    	if(typeof(localStorageHelper) != "undefined"){
			nextRepeatedDeliveryDateCookieValue = localStorageHelper.get("isWhishListButtonClicked",false);
			if(nextRepeatedDeliveryDateCookieValue == 'yes'){
				if(dojo.byId("addToShoppingList") != null){
    		eval(dojo.getAttr("addToShoppingList","href"));
    	}
				productDisplayJS.addtoWIshListClickedRemoved();
			}
		}
    	}


    	    }

}),
wc.render.declareRefreshController({
	id: "PetcoRepeatDeliveryItemsDisplayAreaController",
	renderContext: wc.render.getContextById("PetcoRepeatDeliveryItemsDisplay_Context"),
	url: "",
	formId: ""

		,
	renderContextChangedHandler: function(message, widget) {
		var controller = this;
		var renderContext = this.renderContext;
		widget.refresh(renderContext.properties);
  	},  
	postRefreshHandler: function(widget) {
  		if(dojo.byId("isLoginPopUpForceFullyClosed") != null && dojo.byId("isLoginPopUpForceFullyClosed").value == "true"){
				setTimeout(function(){dojo.byId("isLoginPopUpForceFullyClosed").value = "false"},5000);
				var logonIdErrorMSgPopUp_div = dojo.byId('promptTologinError');
				var logonIdErrorMSgPopUpInfo_div = dojo.byId('promptTologinErrorInfo');
				if(logonIdErrorMSgPopUp_div != null && logonIdErrorMSgPopUpInfo_div != null ){
					logonIdErrorMSgPopUp_div.className= "collapsible open";
					logonIdErrorMSgPopUp_div.innerHTML = '<p class="error-box margin-top-lg">'+ logonIdErrorMSgPopUpInfo_div.innerHTML+ '</p>';
				}
		}
		if(dojo.byId("isUniqueEmail_forChekingRdOrder") != null && dojo.byId("isUniqueEmail_forChekingRdOrder").value == "false"){
			if( dojo.byId("isRDOrder") != null &&  dojo.byId("isRDOrder").value == "true"){
				if(dojo.byId("singleOrderSummary2") != null){
				  dojo.attr(dojo.byId("singleOrderSummary2"), "disabled", "disabled");
				}
				if(dojo.byId("singleOrderSummary") != null){
				  dojo.attr(dojo.byId("singleOrderSummary"), "disabled", "disabled");
				}
				if(dojo.byId("create-account-no") != null ){
					dojo.byId("create-account-no").style.display = "none";
				}

							}else if(dojo.byId("isRDOrder") != null &&  dojo.byId("isRDOrder").value == "false"){
				if(dojo.byId("singleOrderSummary2") != null){
				  dojo.removeAttr(dojo.byId("singleOrderSummary2"), "disabled");
				}
				if(dojo.byId("singleOrderSummary") != null){
				  dojo.removeAttr(dojo.byId("singleOrderSummary"), "disabled");
				}
				if(dojo.byId("create-account-no") != null ){
					dojo.byId("create-account-no").style.display = "block";
				}
			}		
		}
		if(dojo.byId("isRDOrder") != null &&  dojo.byId("isRDOrder").value == "true"){
			if(document.getElementById("isPoAddress") && document.getElementById("isPoAddress").value == 'true'){
				document.getElementById("poAddressMessage").style = "display:block";
			}
			else{
				document.getElementById("poAddressMessage").style = "display:none";
			}
		}
		else if(document.getElementById("poAddressMessage")){
			document.getElementById("poAddressMessage").style = "display:none";
		}
  		var controller = this;
  		var renderContext = this.renderContext;
  	} 
}),


wc.render.declareRefreshController({
	id: "petcoPaypalAreaController",
	renderContext: wc.render.getContextById("petcoPaypalAreaContext"),
	url: getAbsoluteURL()+"PayPal",
	formId: ""
	,
	renderContextChangedHandler: function(message, widget) {
		var controller = this;
		var renderContext = this.renderContext;
		widget.refresh(renderContext.properties);
  	},  
	postRefreshHandler: function(widget) {
  		if(dojo.byId("existingNCR") != null && dojo.byId("PAYPAL_existingNCR") != null){
  			dojo.byId("existingNCR").value=dojo.byId("PAYPAL_existingNCR").value;
		}
  		if(dojo.byId("existingPiId") != null && dojo.byId("PAYPAL_existingPPI") != null){
  			dojo.byId("existingPiId").value=dojo.byId("PAYPAL_existingPPI").value;
		}
  		if(dojo.byId("existingPayPal") != null && dojo.byId("PAYPAL_existingPayPal") != null){
  			dojo.byId("existingPayPal").value=dojo.byId("PAYPAL_existingPayPal").value;
		}
  		if(dojo.byId("activeTab") != null && dojo.byId("PAYPAL_activeTab") != null){
  			dojo.byId("activeTab").value=dojo.byId("PAYPAL_activeTab").value;
		}

  		  		if(dojo.query('input[type="hidden"][name="existingPiIdAll"]').length > 0 && dojo.byId("PAYPAL_existingPI") != null){
  			dojo.query('input[type="hidden"][name="existingPiIdAll"]')[0].value=dojo.byId("PAYPAL_existingPI").value;
  		}
  		if( dojo.byId("PAYPAL_onloadFunction") != null){
  			eval(dojo.byId("PAYPAL_onloadFunction").innerHTML);
  		}


  		  		  		if(dojo.byId("paymentMethodPayPal") != null && dojo.byId("paymentMethodPayPal").checked && dojo.byId("paypal") != null){
  			dojo.addClass(dojo.byId("paypal"),"show");
  			dojo.removeClass(dojo.byId("paypal"),"no-show");
  		}
  		CheckoutPayments.disableEnableActivePaymentTab();
  	} 
}),

wc.render.declareRefreshController({
	id: "petcoCheckoutShippingAddressController",
	renderContext: wc.render.getContextById("petcoCheckoutShippingAddress_Context"),
	url: "",
	formId: ""


	   ,renderContextChangedHandler : function(message, widget) {
	   var controller = this;
	   var renderContext = this.renderContext;
	   widget.refresh(renderContext.properties);
   },
   postRefreshHandler: function(widget) {
	   CheckoutHelperJS.showModal('selectAddress','deep');
	   $('#savedAddressClose').focus();
   }


   }),
wc.render.declareRefreshController({
	id: "PetcoBOPUSHoursDetailsArea_Controller",
	renderContext: wc.render.getContextById("PetcoBOPUSHoursDetailsArea_Context"),
	url: "",
	formId: ""


	   ,renderContextChangedHandler : function(message, widget) {
	   var controller = this;
	   var renderContext = this.renderContext;
	   widget.refresh(renderContext.properties);
   },
   postRefreshHandler: function(widget) {
	  if($("#SPC_lsa_hours").length > 0 && $("#dateValToDIsplay").length > 0 ){
		  $("#SPC_lsa_hours").html($("#dateValToDIsplay").html());
	  } 
   }
}),
wc.render.declareContext("petcoHomePagePalsInfo_Context",null,"");
wc.render.declareRefreshController({
   id: "petcoHomePagePalsInfoController",
   renderContext: wc.render.getContextById("petcoHomePagePalsInfo_Context"),
   url: getAbsoluteURL()+"PetcoPalsInfoView?catalogId=10051&langId=-1&storeId=10151",
   formId: "" ,
   renderContextChangedHandler: function(message, widget) {
		  var controller = this;
		  var renderContext = this.renderContext;
		  widget.refresh(renderContext.properties);
   },
   postRefreshHandler: function(widget) {
	   var currentStep = 1;	
		$('.page-next').click(function(){
			currentStep++;
			$('.pals-rewards-box').addClass('hide');
			$('.page-prev').removeClass('hide');
			$('#pals-rewards-box-' + currentStep).removeClass('hide');
			if (currentStep === $('.pals-rewards-box').length) {
				$('.page-next').addClass('hide');
			}
		});
		$('.page-prev').click(function(){
			if(currentStep > 1) {
				currentStep--;
				$('.pals-rewards-box').addClass('hide');
				$('.page-next').removeClass('hide');
				$('#pals-rewards-box-' + currentStep).removeClass('hide');
				if (currentStep === 1) {
					$('.page-prev').addClass('hide');
				}
			}
		});
		if($('.pals-rewards-box').length == 0) {
			$('.pals-rewards-container').addClass('pals-rewards-container-space padding-left-none');
			$('.pals-rewards-details').addClass('margin-left-none');
			}

		   }
}),
wc.render.declareRefreshController({
	id: "PetcoRxPetVetDisplayAreaController",
	renderContext: wc.render.getContextById("PetcoRxPetVetDisplayAreaContext"),
	url: "",
	formId: ""


	   ,renderContextChangedHandler : function(message, widget) {
	   var controller = this;
	   var renderContext = this.renderContext;
	   widget.refresh(renderContext.properties);
   },
   postRefreshHandler: function(widget) {
	   $('.rxmed-approval-method').click(function() {
		   	var id = $(this).attr('id');
			var identifier = id.split("_");
			var orderItemId = identifier[identifier.length - 2];
			var loopIndex = identifier[identifier.length - 1];
			var petDataContainer = $('#rxMedPetDataSelection_Container_' + orderItemId + '_' + loopIndex);
			var vetDataContainer = $('#rxMedVetDataSelection_Container_' + orderItemId + '_' + loopIndex);
			var approvalMethod = $(this).val();
			$('#'+id).addClass('selected');
		});
	   $.each($('select[id^="rxMedApprovalMethodSelection_"]'),function(i,obj){
		   if(obj.value == "online"){
			   $.each($('select[id^="rxMedPetDataSelection_"]'),function(i,obj){
				    var id = this.id;
				    var identifier = id.split("_");
				    var orderItemId = identifier[identifier.length - 2];
				    var petDataContainer = $('#rxMedPetDataSelection_Container_' + orderItemId + '_1');
					var vetDataContainer = $('#rxMedVetDataSelection_Container_' + orderItemId + '_1');
				    if("" != $('#rxMedPetDataSelection_' + orderItemId + '_1').val()){
				    	petDataContainer.removeClass('hide');
				    	vetDataContainer.removeClass('hide');
				    }
				});
		   }else if(obj.value == "mail"){
			   $.each($('select[id^="rxMedPetDataSelection_"]'),function(i,obj){
				   var id = this.id;
				   var identifier = id.split("_");
				   var orderItemId = identifier[identifier.length - 2];
				   var petDataContainer = $('#rxMedPetDataSelection_Container_' + orderItemId + '_1');
				   var vetDataContainer = $('#rxMedVetDataSelection_Container_' + orderItemId + '_1');
				   var mailingMsgContainer = $('#mailing_msg_' + orderItemId);
				   mailingMsgContainer.removeClass('hide');
				   petDataContainer.removeClass('hide');
				});
		   }
		   var isPetWeightAlertMsgEnable =$('#isPetWeightAlertMsgEnable');
		   if(isPetWeightAlertMsgEnable && isPetWeightAlertMsgEnable.val()=='true'){
			   if($('#petChangemodel').val()!=""&&$('#'+$('#petChangemodel').val()).size()>0){
				   petcoCommonJS.showModal($('#petChangemodel').val());
			   	}
			   $('#petChangemodel').val("");
		   }
	   })
	   var controller = this;
	   var renderContext = this.renderContext;
	   var isCorruptedData = controller.renderContext.properties["isCorruptedData"];	
	   var corruptedPetId =  controller.renderContext.properties["corruptedPetId"];
	   var corruptedOrderItemId =  controller.renderContext.properties["corruptedOrderItemId"];
	   if(isCorruptedData){
		   petcoPersonalizationJS.rxMedUpdateMandatoryPetInfo(corruptedOrderItemId,corruptedPetId);
	   }

	   	   toggle(dojo.byId("prescription-information-section"));
	   toggle(dojo.byId("prescription-information-section"));
	   $("#prescription-information").removeClass("hide");
	   cursor_clear();
	   CheckoutHelperJS.disablePlaceOrderButton();

	      }

   }),
wc.render.declareRefreshController({
	id: "PetcoMyAccountHeaderController",
	renderContext: wc.render.getContextById("PetcoMyAccountHeaderContext"),
	url: getAbsoluteURL()+"MyAccountPalsHeaderView?catalogId="+WCParamJS.catalogId+"&langId="+WCParamJS.langId+"&storeId="+WCParamJS.storeId,
	formId: ""
   ,renderContextChangedHandler : function(message, widget) {
	   var controller = this;
	   var renderContext = this.renderContext;
	   widget.refresh(renderContext.properties);
   },
   postRefreshHandler: function(widget) {

	      }
}),
wc.render.declareRefreshController({
	id: "PetcoInterstitialCartPopUpAreaController",
	renderContext: wc.render.getContextById("PetcoInterstitialCartPopUpAreaContext"),
	url: getAbsoluteURL()+"PetcoInterstitialATCPopup?catalogId="+WCParamJS.catalogId+"&langId="+WCParamJS.langId+"&storeId="+WCParamJS.storeId,
	formId: ""
   ,renderContextChangedHandler : function(message, widget) {
	   var controller = this;
	   var renderContext = this.renderContext;
	   widget.refresh(renderContext.properties);
	   dojo.topic.publish('PDPAddToCartModal_open', "true");
   },
   postRefreshHandler: function(widget) {
	   var controller = this;
	   var renderContext = this.renderContext;
	   persistentPDP();
	   cursor_clear();
	   petcoCommonJS.showModal('cartListItems');
	   $('.carousel[data-wrap="false"]').bind('slid.bs.carousel', function(e){  
		    var $this = $(this);
		    $this.children('.carousel-control').removeClass('disabled');
		    if ($this.find('.item:last').hasClass('active')){
		        $this.children('.right').addClass('disabled');
		    } else if ($this.find('.item:first').hasClass('active')){
		        $this.children('.left').addClass('disabled');
		    }
		    });
		if(document.getElementById("cartInterstitialTagging")!= 'undefined' && document.getElementById("cartInterstitialTagging") != null){
		   eval($("script#cartInterstitialTagging").html());
		}

	      }
}),
wc.render.declareRefreshController({
   id: "PetcoTipSectionAreaController",
   renderContext: wc.render.getContextById("petcoTipSection_Context"), 
   url:"",
   formId: "" ,
   renderContextChangedHandler: function(message, widget) {
		  var controller = this;
		  var renderContext = this.renderContext;
		  widget.refresh(renderContext.properties);
   },
   postRefreshHandler: function(widget) { 
   		CheckoutHelperJS.deliveryInstructionRefresh();
   }
});